<style lang="scss" scoped>
.show-wrapper{
  margin-top: 189px;
  &-content{
    &-top{
      &-tv{
        margin: 0 auto;
        width: 986px;
        height: 684px;
        margin-top: 35px;
        margin-bottom: 2px;
        background: url('./../assets/img/dianshiji-pc.svg') no-repeat;
        background-size: cover;
        overflow: hidden;
        &-title{
          font-size:24px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(15,74,191,1);
          line-height:33px;
          margin-top: 27px;
        }
        &-content{
          overflow: hidden;
          margin: 0 auto;
          margin-top: 54px;
          margin-bottom: 51px;
          width:890px;
          height:474px;
          border-radius:31px;
          background-color: #fff;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      &-rule{
        margin-top: 8px;
        display: block;
        font-size:12px;
        font-size:18px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:25px;
        text-decoration:underline;
        cursor: pointer;
      }
    }
  }
}
</style>

<template>
  <div class="show-wrapper" id="show">
    <div class="wrapper-reset">
      <Title v-if="showOrderData" :title="showOrderData.title"></Title>
      <div class="show-wrapper-content">
        <div class="show-wrapper-content-top">
          <div class="show-wrapper-content-top-tv">
            <p class="show-wrapper-content-top-tv-title">{{showOrderData.desc}}</p>
            <div class="show-wrapper-content-top-tv-content" style="color: red">
              <img :src="showOrderData.cover" alt="">
            </div>
          </div>
          <BigButton :text="showOrderData.button" :link="showOrderData.buttonLink" @click.native="statistics"></BigButton>
          <span class="show-wrapper-content-top-rule" @click="statisticsLink(showOrderData.extraLink)">{{showOrderData.extra}}</span>
        </div>
        <LotteryCalendar></LotteryCalendar>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/Title';
import BigButton from '@/components/bigButton';
import LotteryCalendar from '@/components/LotteryCalendar';
export default {
  components: {
    Title,
    BigButton,
    LotteryCalendar,
  },
  data() {
    return {
      showOrderData: {},
    }
  },
  methods: {
    statistics() {
      this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_share_share_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}});
    },
    statisticsLink(link) {
      this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_share_rule_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}});
      window.open(link);
    }
  },
  mounted () {
    this.$bus.on('showOrderData', (data) => {
      this.showOrderData = data;
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/blocks/ShowOrder.vue